module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "emailSetting",
    attrs: {
      "element-loading-text": _vm.$t('common.loading')
    }
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('setting.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('setting.crumbs.L2')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('setting.panel.mailSetup')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper"
  }, [_c('div', {
    staticClass: "gray-explain"
  }, [_vm._v(_vm._s(_vm.$t('setting.panel.explain')))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.formrules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('overseaForget.emailAddr')
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-230",
    attrs: {
      "size": "small",
      "type": "text"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.addEmail
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.ok')))])])], 1), _vm._v(" "), (_vm.emails.length > 0) ? _c('div', {
    staticClass: "emails-box"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('overseaForget.emailAddr')) + ":")]), _vm._v(" "), _c('ul', {
    staticClass: "emails-list"
  }, _vm._l((_vm.emails), function(email, index) {
    return _c('li', [_vm._v(_vm._s(email) + " "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.delEmail(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.del')))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('setting.panel.dailySend'),
      "prop": "status"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-color": "#7ed321",
      "off-color": "#d8d8d8",
      "on-value": "1",
      "off-value": "0",
      "disabled": _vm.emails.length ? false : true
    },
    on: {
      "change": _vm.sendChange
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-70e35a28"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/emailSetting/emailSetting.vue
// module id = 924
// module chunks = 0